import Chip from '@mui/material/Chip';
import { Props } from './types';
import { forwardRef } from 'react';
import getPrefixClassNames from '../../utils/getPrefixClassNames';
import { customShapeClasses } from '../../theme/overrides/Chip';

const Badge = forwardRef<HTMLDivElement, Props>(
  (
    {
      shape = 'fullRounded',
      color = 'grey',
      variant = 'filled',
      className,
      ...otherProps
    },
    ref,
  ) => {
    return (
      <Chip
        className={`${getPrefixClassNames(
          customShapeClasses[shape],
          color,
        )} ${className}`}
        color={color}
        variant={variant}
        {...otherProps}
        ref={ref}
      />
    );
  },
);

export default Badge;
